import React from 'react';
import { connect } from 'react-redux';
import AsyncSelect from "react-select/async";
import axios from 'axios';
import ErrorValidation from '../../../services/ErrorValidation';
import Ax from '../../../components/hoc/Ax';
import ReactSelectStyle from '../../../components/ui/ReactSelectStyle';

class InputAssetSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            defaultOptions: [],
        };
        this.cancelToken = null;
        this.apiTimeout = null;
    }
    
    onInputChange = (selectedOption) => {
        this.setState({ selectedOption });
        if (this.props.changeEvent) {
            this.props.changeEvent(selectedOption);
        }
    };
    
    displayStringSearch = (assets) => {
        return assets.map(asset => ({
            label : asset.asset_name + " ("+asset.asset_nickname+")",
            value: asset.id,
            master_id: this.props.master_id,
            data: asset 
        }));
    };
    
    loadingOptions = (inputText, callback) => {
        if (inputText.length > 2) {
            clearTimeout(this.apiTimeout);
            if (this.cancelToken) {
                this.cancelToken.cancel("Operation canceled due to new request.");
            }
            this.cancelToken = axios.CancelToken.source();

            this.apiTimeout = setTimeout(() => {
                this.getLoadingOptions({
                    search_by_text: inputText,
                    master_id: this.props.master_id ,
                    only_iot_unlinked_asset: this.props.only_iot_unlinked_asset ? "Y" : "N"
                }, callback);
            }, 500);
        } else {
            callback([]);
        }
    };

    getLoadingOptions = (params, callback) => {
        axios({
            method: 'GET',
            headers: { 
                'Accept': 'application/json', 
                'Content-Type': 'application/json', 
                'Authorization': 'Bearer ' + this.props.access_token 
            },
            params: params,
            url: process.env.REACT_APP_SERVER_PATH + '/backoffice/group/asset/list',
            cancelToken: this.cancelToken.token
        })
        .then((response) => {
            callback(this.displayStringSearch(response.data.data || []));
        })
        .catch((err) => {
            if (!axios.isCancel(err)) {
                ErrorValidation.apiErrorHandle(err, 'Unable to fetch assets.');
                callback([]);
            }
        });
    };
    
    render() {
        return (
            <Ax>
                <div className="asset-search-container">
                    <AsyncSelect
                        styles={ReactSelectStyle(this.props)}
                        menuPlacement="bottom"
                        placeholder={this.props.placeholder || "Search Asset by Name or ID"}
                        loadingMessage={(input) => {
                            if (input.inputValue && input.inputValue.length <= 2) {
                                return 'Please enter 3 or more characters';
                            } else {
                                return 'Searching...';
                            }
                        }}
                        noOptionsMessage={(input) => {
                            if (input.inputValue.length === 0) {
                                return 'Please enter 3 or more characters';
                            } else {
                                return 'No assets found';
                            }
                        }}
                        onChange={this.onInputChange}
                        isClearable={this.props.isClearable}
                        loadOptions={this.loadingOptions}
                        value={this.state.selectedOption}
                        isMulti={this.props.isMulti}
                        required={this.props.required}
                        isDisabled={this.props.disabled || false}
                    />
                    <input
                        name={this.props.name || 'asset'}
                        tabIndex={-1}
                        required={this.props.required || false}
                        value={this.state.selectedOption ? this.state.selectedOption.label : ''}
                        onChange={() => {}}
                        style={{
                            opacity: 0,
                            width: 0,
                            height: 0,
                            padding: 0,
                            margin: 0,
                            display: 'table'
                        }}
                    />
                </div>
            </Ax>
        );
    }
}

const mapStateToProps = state => ({
    access_token: state.auth.access_token
});

export default connect(mapStateToProps)(InputAssetSearch);